// extracted by mini-css-extract-plugin
module.exports = {"Sales":"OrderDetail_Sales__1mTiQ","TitleSale":"OrderDetail_TitleSale__1eVbt","TitleSale1":"OrderDetail_TitleSale1___iey4","BtnChange1":"OrderDetail_BtnChange1__ud-LX"};